import axios from 'axios';
import { FORBIDDEN_ROUTE } from 'commons/constants/app';
import { TOKEN } from 'commons/constants/store';
import { tryToRefreshToken } from './refresh';

function createClient(baseUrl?: string) {
  const client = axios.create({
    baseURL: baseUrl,
  });

  client.interceptors.request.use(config => {
    if (!config.headers?.['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    if (!config.headers?.['Authorization']) {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(TOKEN)}`;
    }

    return config;
  });

  client.interceptors.response.use(
    response => response,
    async error => {
      const message: string = error.message ?? '';
      const status = error.response?.status ?? 500;
      if (status === 401) return tryToRefreshToken(client, error.config);
      if (status === 403) window.location.assign(FORBIDDEN_ROUTE);

      return Promise.reject({ ...error, status, message });
    }
  );

  return client;
}

export { createClient };
